import React, { useState } from "react";
import KYBVerification from "./KYBVerification";
import SellerFarmerLanguageRegion from "./LanguageRegion";
import SellerFarmerNotification from "./Notification";
import SellerFarmerPolicySecurity from "./PolicySecurity";
import SellerFarmerKYC from "./KycVerification";

const SellerFarmerSetting = () => {
  const [activeTab, setActiveTab] = useState("KYB Verification");
  const tabs = [
    "KYB Verification",
    "KYC Verification",
    "Language & Region",
    "Notifications",
    "Privacy & Security",
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "KYB Verification":
        return <KYBVerification />;
      case "Language & Region":
        return <SellerFarmerLanguageRegion />;
      case "Notifications":
        return <SellerFarmerNotification />;
      case "Privacy & Security":
        return <SellerFarmerPolicySecurity />;
      case "KYC Verification":
        return <SellerFarmerKYC />;
      default:
        return <KYBVerification />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SellerFarmerSetting;
